<div class="sticky-bottom-wrapper">
  @if (showMobileAppFooter()) {
    <liberro-basic-layout-native-bottom-bar
      [activeNativeBottomNavbarItem]="activeNativeBottomNavbarItem()"
    ></liberro-basic-layout-native-bottom-bar>
  }
</div>
<div class="layout" [ngStyle]="{'padding-bottom': layoutBottomPadding()}" [style.margin-top]="nativeSafeZoneService.paddings.top + 'px'">
  <liberro-basic-layout-header
    [authenticatedHeader]="authenticatedHeader()"
    [showHeaderHamburger]="showHeaderHamburger()"
    [showHeaderLinks]="showHeaderLinks()"
    [headerBackground]="headerBackground()"
    [isLoginUrl]="isLoginUrl()"
    [onlyLogoHeader]="onlyLogoHeader()"
    [previewOnlyHeaderText]="previewOnlyHeaderText()"
  ></liberro-basic-layout-header>

  <div class="content">
    <router-outlet></router-outlet>
  </div>

  @if (showFooter()) {
    <liberro-basic-layout-footer
      [showFooterLinks]="showFooterLinks()"
      [links]="links()"
      [hotlineAvailability]="hotlineAvailability()"
      (showCookieSettings)="displayCookieConsentBar()"
    ></liberro-basic-layout-footer>
  }

</div>
<liberro-spinner [show]="showLoginLoader()"></liberro-spinner>
<liberro-mobile-explain-tooltip-sheet></liberro-mobile-explain-tooltip-sheet>
